import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SelectionListDefault, SelectionListKey, SelectionListWert } from '../models/selection-list-default.model';

@Injectable({ providedIn: 'root' })
export class SelectionListDefaultService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiBaseUrl}/api/v1/selection-list-defaults`;

  getAll(): Observable<SelectionListDefault[]> {
    return this.http.get<SelectionListDefault[]>(this.apiUrl);
  }

  replace(listKey: SelectionListKey, werte: SelectionListWert[]): Observable<SelectionListDefault> {
    return this.http.put<SelectionListDefault>(`${this.apiUrl}/${listKey}`, { werte });
  }

  reset(listKey: SelectionListKey): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${listKey}`);
  }
}
